import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SpousePersonalInfoFormGroup } from '../../../../models/shared/forms/spouse-personal-info-form-group';

@Component({
  selector: 'app-spouse-personal-information-form',
  templateUrl: './spouse-personal-information-form.component.html',
  styleUrls: ['./spouse-personal-information-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpousePersonalInformationFormComponent {
  @Input() formGroup!: SpousePersonalInfoFormGroup;
  @Input() formSubmitted: boolean = false;
}
